import React from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

export default function Header({
  title = '',
  description = '',
  className = '',
  children = null
}) {
  return (
    <div className={cn(styles.container, className)}>
      <div className={styles.header}>
        <h5>{title}</h5>
        <span>{description}</span>
      </div>
      {children}
    </div>
  );
}
